import { create } from 'zustand';

interface BudgetSearchProps {
  searchText: string;
  setSearchText: (searchTerm: string) => void;
}

const BudgetSearch = create<BudgetSearchProps>((set) => ({
  searchText: '',
  setSearchText: (searchText: string) => set({ searchText })
}));

export default BudgetSearch;
